export default function mobileMenuCtrl($scope) {
    accountScope = angular.element(document.getElementById('account-wrap')).scope();
    $scope.registerUserMobile = function () {
        angular.element(document.getElementById('account-wrap')).scope().registerUserOpen();
    }
}

mobileMenuCtrl.$inject = ['$scope'];